import angular from 'angular';

import {MediasService} from '../../services/medias.services';
import {AudienceController} from './audience.controller';
import {UserOptinImportController} from './user-optin-import.controller';
import {AudienceService} from './audience.service.js';
import {UserOptinImportService} from './user-optin-import.service';
import {dateRangePicker} from './date-range-picker.directive';

angular
  .module('audience', [])
  .controller('AudienceController', AudienceController)
  .controller('UserOptinImportController', UserOptinImportController)
  .factory('AudienceFactory', AudienceService.AudienceFactory)
  .factory('UserOptinImportFactory', UserOptinImportService.UserOptinImportFactory)
  .factory('MediasService', MediasService.MediasFactory)
  .directive('dateRangePicker', dateRangePicker)